import React from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import {
  Box,
  IconButton,
  MenuItem,
  Stack,
  StackProps,
  Tooltip,
} from '@mui/material';

import { StyledBoldInput, StyledLightInput } from './styles';
import { Controller } from 'react-hook-form';
import { UnstyledSelectInput } from 'components/Inputs';
import { requiredMessage } from 'schemas/validators';

const getInputName = (name: string, index: number) =>
  `prescription.${index}.${name}`;

interface Props extends StackProps {
  onDeleteClick: () => void;
  index: number;
}

export const TreatmentPrescriptionMedicamentItem: React.FC<Props> = ({
  onDeleteClick,
  index,
  ...props
}) => {
  return (
    <Stack
      spacing={2}
      flex={1}
      border="1px solid #8E8E8E"
      borderRadius="4px"
      p={2}
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      {...props}
    >
      <Box flex={2}>
        <StyledBoldInput
          name={getInputName('name', index)}
          rules={{ required: requiredMessage('Descrição do medicamento') }}
          placeholder="Descrever medicamento"
          fullWidth
          size="small"
          autoFocus
        />

        <StyledLightInput
          name={getInputName('posology', index)}
          rules={{ required: requiredMessage('Posologia') }}
          placeholder="Posologia"
          fullWidth
          size="small"
        />
      </Box>

      <Box sx={{ flex: 1 }}>
        <Controller
          name={getInputName('way', index)}
          render={({ field }) => {
            return (
              <UnstyledSelectInput
                size="small"
                displayEmpty
                IconComponent={Box}
                sx={
                  !field.value
                    ? {
                        color: '#757575',
                        opacity: 1,
                        fontWeight: 500,
                        fontSize: 14,
                        textTransform: 'uppercase',
                      }
                    : undefined
                }
                {...field}
                value={field.value ?? ''}
              >
                <MenuItem disabled value="">
                  Inserir via
                </MenuItem>
                <MenuItem value="Oral">Oral</MenuItem>
                <MenuItem value="Tópico">Tópico</MenuItem>
                <MenuItem value="Oftálmico">Oftálmico</MenuItem>
                <MenuItem value="Otológico">Otológico</MenuItem>
                <MenuItem value="Ambiente">Ambiente</MenuItem>
              </UnstyledSelectInput>
            );
          }}
        />
      </Box>

      <Box sx={{ flex: 1 }}>
        <StyledBoldInput
          name={getInputName('quantity', index)}
          placeholder="Inserir quantidade"
          fullWidth
          size="small"
        />
      </Box>

      <Box>
        <Tooltip title="Deletar">
          <IconButton aria-label="Deletar" onClick={onDeleteClick}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </Stack>
  );
};
